export const dict = {
  pl: {
    appName: "AI Dating Coach",
    tagline: "Twój prywatny analityk randkowy oparty na AI",
    loginTitle: "Wejdź do panelu",
    loginSubtitle: "Hasło chroni Twoje analizy i rozmowy",
    password: "Hasło",
    login: "Zaloguj",
    invalidPassword: "Nieprawidłowe hasło",
    logout: "Wyloguj",
    dashboard: "Panel",
    newAnalysis: "Nowa analiza",
    newPremium: "Premium: ocena drugiej osoby",
    premiumBadge: "PREMIUM",
    standardBadge: "Standard",
    history: "Historia",
    stats: "Statystyki",
    totalReports: "Łącznie raportów",
    avgScore: "Średnia ocena",
    lastReport: "Ostatni raport",
    noReports: "Brak raportów",
    startFirst: "Rozpocznij pierwszą analizę",
    // Form
    analysisMode: "Tryb analizy",
    modeConversation: "Rozmowa",
    modeConversationDesc: "Wklej rozmowę z czatu",
    modeProfile: "Profil",
    modeProfileDesc: "Opis profilu, bio",
    modePhotos: "Zdjęcia",
    modePhotosDesc: "Ocena zdjęć",
    modeFull: "Pełna analiza",
    modeFullDesc: "Wszystko razem",
    contactName: "Imię / opis kontaktu",
    contactPlaceholder: "np. Ania, Tinder, 24 lata",
    contextText: "Rozmowa / opis",
    contextPlaceholder: "Wklej tutaj rozmowę, opis profilu lub szczegóły sytuacji...",
    aboutYou: "O Tobie (opcjonalnie, dla oceny kompatybilności)",
    aboutYouPlaceholder: "Krótko o sobie: wiek, charakter, czego szukasz, twoje wartości...",
    uploadTitle: "Wrzuć screen lub zdjęcie",
    uploadHint: "JPG, PNG, WebP — przeciągnij lub kliknij",
    uploadMax: "Maks. 8MB na plik, do 4 plików",
    noPressure: "Bez presji",
    noPressureHint: "Luźniejszy ton, mniej desperacki",
    moreFlirty: "Bardziej flirtująco",
    moreFlirtyHint: "Odważniejsze, zabawne propozycje",
    analyze: "Analizuj",
    analyzePremium: "Analiza premium",
    analyzing: "Analizuję...",
    analysisError: "Błąd analizy",
    // Report
    summary: "Podsumowanie",
    scoresTitle: "Wyniki",
    score_response_chance: "Szansa odpowiedzi",
    score_interest: "Zainteresowanie",
    score_meeting_chance: "Szansa spotkania",
    score_chemistry: "Chemia",
    score_ghosting_risk: "Ryzyko urwania",
    score_profile_strength: "Siła profilu",
    score_photo_quality: "Jakość zdjęć",
    score_bio_quality: "Jakość opisu",
    overallScore: "Ogólna ocena",
    positiveSignals: "Pozytywne sygnały",
    negativeSignals: "Negatywne sygnały",
    diagnosis: "Diagnoza",
    nextStep: "Następny krok",
    messageSuggestions: "Propozycje wiadomości",
    msg_safe: "Bezpieczna",
    msg_casual: "Luźna",
    msg_flirty: "Flirtująca",
    msg_specific: "Konkretna",
    donts: "Czego nie robić",
    profileTips: "Sugestie poprawy profilu",
    copy: "Kopiuj",
    copied: "Skopiowano!",
    downloadPdf: "Pobierz PDF",
    share: "Udostępnij linkiem",
    shareCopied: "Link skopiowany — ważny 7 dni",
    tags: "Tagi",
    searchPlaceholder: "Szukaj po imieniu, tytule lub tagu...",
    filterAll: "Wszystkie",
    filterPremium: "Premium",
    filterStandard: "Standard",
    // History
    historyTitle: "Historia analiz",
    delete: "Usuń",
    view: "Zobacz",
    confirmDelete: "Na pewno usunąć ten raport?",
    deleted: "Raport usunięty",
    back: "Wróć",
    backToDashboard: "Wróć do panelu",
    loading: "Ładowanie...",
    mode: "Tryb",
    language: "Język",
    sessionExpired: "Sesja wygasła. Zaloguj się ponownie.",
    // Premium / billing
    premiumTitle: "Premium: ocena drugiej osoby",
    premiumSubtitle: "Głęboka analiza psychologiczna: MBTI, styl przywiązania, red/green flags, kompatybilność i strategia podejścia.",
    premiumIntro: "Każdy raport premium kosztuje 2 kredyty. Wykup pakiet lub subskrypcję, żeby zacząć.",
    needCredits: "Raport Premium wymaga minimum 2 kredytów",
    creditsBalance: "Saldo kredytów",
    subscriptionActive: "Subskrypcja aktywna",
    subscriptionUntil: "Aktywna do",
    cancelSubscription: "Wyłącz auto-odnowienie",
    cancelSubscriptionHint: "Zachowasz dostęp do końca opłaconego okresu. Bez nowych obciążeń.",
    confirmCancelSub: "Wyłączyć auto-odnowienie subskrypcji? Zachowasz dostęp do końca okresu.",
    resumeSubscription: "Wznów auto-odnowienie",
    subscriptionCanceled: "Auto-odnowienie wyłączone",
    subscriptionResumed: "Auto-odnowienie wznowione",
    canceledNotice: "Auto-odnowienie wyłączone — dostęp do",
    autoRenews: "Odnawia się automatycznie",
    streamingProgress: "Generuję raport...",
    streamingHint: "Raport pojawia się stopniowo dzięki streamingowi AI",
    streamingDone: "Gotowe!",
    buy: "Kup",
    payWithCard: "Zapłać kartą",
    payWithCrypto: "Zapłać kryptowalutą",
    package_single: "Jednorazowo — 1 raport premium",
    package_single_desc: "Najlepsze gdy chcesz tylko sprawdzić",
    package_pack10: "10 kredytów premium",
    package_pack10_desc: "Najlepsza wartość — 22% taniej",
    package_monthly: "15 kredytów co miesiąc",
    package_monthly_desc: "Odnawialny pakiet dla aktywnych użytkowników",
    paymentSuccess: "Płatność udana!",
    paymentSuccessMessage: "Twoje uprawnienia zostały dodane.",
    paymentPending: "Sprawdzam status płatności...",
    paymentFailed: "Płatność nieudana lub anulowana",
    goToPremium: "Przejdź do Premium",
    startPremium: "Rozpocznij analizę premium",
    // Premium report sections
    personality: "Profil psychologiczny",
    mbti: "MBTI",
    bigFive: "Wielka Piątka",
    loveLanguage: "Język miłości",
    communicationStyle: "Styl komunikacji",
    coreValues: "Wartości",
    attachmentStyle: "Styl przywiązania",
    confidence: "Pewność",
    evidence: "Dowody",
    implications: "Implikacje",
    redFlags: "Red flags",
    greenFlags: "Green flags",
    compatibility: "Kompatybilność",
    strengths: "Mocne strony",
    frictionPoints: "Punkty tarcia",
    verdict: "Werdykt",
    longTermPrediction: "Predykcja długoterminowa",
    relationshipPotential: "Potencjał na związek",
    shortFlingLikelihood: "Krótka znajomość",
    ghostRisk: "Ryzyko zniknięcia",
    timeline: "Oczekiwana oś czasu",
    reasoning: "Uzasadnienie",
    approachStrategy: "Strategia podejścia",
    openerMessage: "Wiadomość otwierająca",
    firstDateIdea: "Pomysł na pierwszą randkę",
    pace: "Tempo",
    topicsExplore: "Tematy do poruszenia",
    topicsAvoid: "Tematów unikaj",
    milestones: "Kamienie milowe",
    finalRecommendation: "Rekomendacja końcowa",
    sharedReportNotice: "Współdzielony raport — wygasa",
    expiresOn: "Wygasa",
    shareExpired: "Link wygasł lub nie istnieje",
    // Landing
    landingEyebrow: "Załóż konto · 1 kredyt premium gratis",
    landingTitlePart1: "Rozszyfruj jej profil,",
    landingTitlePart2: "zanim klikniesz „lubię to”.",
    landingSubtitle: "Wrzuć screen z Tindera albo wklej rozmowę. AI odda Ci pełną analizę psychologiczną — MBTI, styl przywiązania, red flagi, szansa na spotkanie i gotowe wiadomości otwierające.",
    landingFeatPersonality: "MBTI · Big5 · Attachment",
    landingFeatVision: "Vision na screenach",
    landingFeatChat: "Analiza rozmowy",
    landingFeatPremium: "Premium streaming",
    landingEmailLabel: "Email — dostęp do panelu + kurs 7 dni",
    landingEmailPlaceholder: "ty@example.com",
    landingCta: "Zarejestruj się",
    landingTrust: "Rejestracja darmowa · 1 kredyt premium na start · Kurs 7 dni w mailu.",
    landingSkip: "Mam już konto — zaloguj",
    landingThanks: "Dzięki! Witamy w panelu.",
    landingEmailInvalid: "Podaj poprawny adres email",
    landingHowTitle: "Trzy kroki do prawdy",
    landingHowSubtitle: "Każda analiza zajmuje 15-40 sekund",
    landingStep1Title: "Wrzuć screen lub rozmowę",
    landingStep1Desc: "JPG/PNG ze screenem z Tindera, Bumble albo cały tekst rozmowy.",
    landingStep2Title: "AI patrzy i myśli",
    landingStep2Desc: "Vision model czyta zdjęcia, bio, sygnały. Deep model robi diagnozę psychologiczną.",
    landingStep3Title: "Dostajesz strategię",
    landingStep3Desc: "Konkretna wiadomość, pomysł na pierwszą randkę i czego unikać.",
    premiumStreamReveal: "Sekcje pojawiają się jedna po drugiej",
    premiumStreamWaiting: "AI generuje raport sekcja po sekcji...",
    couponLabel: "Masz kod rabatowy?",
    couponApply: "Zastosuj",
    couponClear: "Usuń kod",
    couponApplied: "Kod aktywny — {p}% zniżki",
    couponInvalid: "Kod nieważny, wygasł lub już użyty",
    couponExpires: "Ważny do",
    standardAnalysis: "Analiza standard",
    uploadSlotMain: "główne zdjęcie",
    uploadSlotExtra: "dodatkowe",
    previewNoPhoto: "Wrzuć zdjęcie żeby zobaczyć podgląd",
    previewUnnamed: "Nieznany profil",
    mode_conversation: "Rozmowa",
    mode_profile: "Profil",
    mode_photos: "Zdjęcia",
    mode_full: "Pełna",
  },
  en: {
    appName: "AI Dating Coach",
    tagline: "Your private AI-powered dating analyst",
    loginTitle: "Enter the panel",
    loginSubtitle: "A password protects your analyses and conversations",
    password: "Password",
    login: "Log in",
    invalidPassword: "Invalid password",
    logout: "Log out",
    dashboard: "Dashboard",
    newAnalysis: "New analysis",
    newPremium: "Premium: deep profile",
    premiumBadge: "PREMIUM",
    standardBadge: "Standard",
    history: "History",
    stats: "Stats",
    totalReports: "Total reports",
    avgScore: "Average score",
    lastReport: "Last report",
    noReports: "No reports yet",
    startFirst: "Start your first analysis",
    analysisMode: "Analysis mode",
    modeConversation: "Conversation",
    modeConversationDesc: "Paste a chat conversation",
    modeProfile: "Profile",
    modeProfileDesc: "Profile description, bio",
    modePhotos: "Photos",
    modePhotosDesc: "Rate photos",
    modeFull: "Full analysis",
    modeFullDesc: "Everything combined",
    contactName: "Name / contact description",
    contactPlaceholder: "e.g. Anna, Tinder, 24",
    contextText: "Conversation / description",
    contextPlaceholder: "Paste the conversation, profile bio, or details of the situation here...",
    aboutYou: "About you (optional, for compatibility scoring)",
    aboutYouPlaceholder: "Briefly about you: age, character, what you're looking for, your values...",
    uploadTitle: "Upload screenshot or photo",
    uploadHint: "JPG, PNG, WebP — drag or click",
    uploadMax: "Max 8MB per file, up to 4 files",
    noPressure: "No pressure",
    noPressureHint: "Lighter tone, less desperate",
    moreFlirty: "More flirty",
    moreFlirtyHint: "Bolder, playful suggestions",
    analyze: "Analyze",
    analyzePremium: "Run premium analysis",
    analyzing: "Analyzing...",
    analysisError: "Analysis error",
    summary: "Summary",
    scoresTitle: "Scores",
    score_response_chance: "Response chance",
    score_interest: "Interest",
    score_meeting_chance: "Meeting chance",
    score_chemistry: "Chemistry",
    score_ghosting_risk: "Ghosting risk",
    score_profile_strength: "Profile strength",
    score_photo_quality: "Photo quality",
    score_bio_quality: "Bio quality",
    overallScore: "Overall score",
    positiveSignals: "Positive signals",
    negativeSignals: "Negative signals",
    diagnosis: "Diagnosis",
    nextStep: "Next step",
    messageSuggestions: "Message suggestions",
    msg_safe: "Safe",
    msg_casual: "Casual",
    msg_flirty: "Flirty",
    msg_specific: "Specific",
    donts: "What not to do",
    profileTips: "Profile improvement tips",
    copy: "Copy",
    copied: "Copied!",
    downloadPdf: "Download PDF",
    share: "Share via link",
    shareCopied: "Link copied — valid for 7 days",
    tags: "Tags",
    searchPlaceholder: "Search by name, title or tag...",
    filterAll: "All",
    filterPremium: "Premium",
    filterStandard: "Standard",
    historyTitle: "Analysis history",
    delete: "Delete",
    view: "View",
    confirmDelete: "Are you sure you want to delete this report?",
    deleted: "Report deleted",
    back: "Back",
    backToDashboard: "Back to dashboard",
    loading: "Loading...",
    mode: "Mode",
    language: "Language",
    sessionExpired: "Session expired. Please log in again.",
    premiumTitle: "Premium: deep profile of the other person",
    premiumSubtitle: "Deep psychological analysis: MBTI, attachment style, red/green flags, compatibility and approach strategy.",
    premiumIntro: "Each premium report costs 2 credits. Buy a pack or subscribe to start.",
    needCredits: "A Premium report requires at least 2 credits",
    creditsBalance: "Credits balance",
    subscriptionActive: "Active subscription",
    subscriptionUntil: "Active until",
    cancelSubscription: "Cancel auto-renewal",
    cancelSubscriptionHint: "Keep access until the end of the paid period. No future charges.",
    confirmCancelSub: "Cancel auto-renewal? You keep access until end of period.",
    resumeSubscription: "Resume auto-renewal",
    subscriptionCanceled: "Auto-renewal canceled",
    subscriptionResumed: "Auto-renewal resumed",
    canceledNotice: "Auto-renewal off — access until",
    autoRenews: "Auto-renews monthly",
    streamingProgress: "Generating report...",
    streamingHint: "Report appears progressively thanks to AI streaming",
    streamingDone: "Done!",
    buy: "Buy",
    payWithCard: "Pay with card",
    payWithCrypto: "Pay with crypto",
    package_single: "One-off — 1 premium report",
    package_single_desc: "Best if you just want to try",
    package_pack10: "10 premium credits",
    package_pack10_desc: "Best value — 22% off",
    package_monthly: "15 credits every month",
    package_monthly_desc: "Recurring package for active users",
    paymentSuccess: "Payment successful!",
    paymentSuccessMessage: "Your entitlements have been added.",
    paymentPending: "Checking payment status...",
    paymentFailed: "Payment failed or cancelled",
    goToPremium: "Go to Premium",
    startPremium: "Start premium analysis",
    personality: "Personality",
    mbti: "MBTI",
    bigFive: "Big Five",
    loveLanguage: "Love language",
    communicationStyle: "Communication style",
    coreValues: "Core values",
    attachmentStyle: "Attachment style",
    confidence: "Confidence",
    evidence: "Evidence",
    implications: "Implications",
    redFlags: "Red flags",
    greenFlags: "Green flags",
    compatibility: "Compatibility",
    strengths: "Strengths",
    frictionPoints: "Friction points",
    verdict: "Verdict",
    longTermPrediction: "Long-term prediction",
    relationshipPotential: "Relationship potential",
    shortFlingLikelihood: "Short fling likelihood",
    ghostRisk: "Ghost risk",
    timeline: "Expected timeline",
    reasoning: "Reasoning",
    approachStrategy: "Approach strategy",
    openerMessage: "Opener message",
    firstDateIdea: "First date idea",
    pace: "Pace",
    topicsExplore: "Topics to explore",
    topicsAvoid: "Topics to avoid",
    milestones: "Milestones",
    finalRecommendation: "Final recommendation",
    sharedReportNotice: "Shared report — expires",
    expiresOn: "Expires",
    shareExpired: "This link expired or doesn't exist",
    // Landing
    landingEyebrow: "Create an account · 1 free premium credit",
    landingTitlePart1: "Decode her profile",
    landingTitlePart2: "before you tap „like”.",
    landingSubtitle: "Drop a Tinder screenshot or paste your conversation. AI returns a full psychological analysis — MBTI, attachment style, red flags, meeting odds and ready-to-send opener messages.",
    landingFeatPersonality: "MBTI · Big5 · Attachment",
    landingFeatVision: "Vision on screenshots",
    landingFeatChat: "Conversation analysis",
    landingFeatPremium: "Premium streaming",
    landingEmailLabel: "Email — dashboard access + 7-day course",
    landingEmailPlaceholder: "you@example.com",
    landingCta: "Sign up",
    landingTrust: "Free signup · 1 premium credit to start · 7-day course by email.",
    landingSkip: "I already have an account",
    landingThanks: "Thanks! Welcome to the panel.",
    landingEmailInvalid: "Enter a valid email address",
    landingHowTitle: "Three steps to clarity",
    landingHowSubtitle: "Each analysis runs in 15-40 seconds",
    landingStep1Title: "Drop a screenshot or chat",
    landingStep1Desc: "JPG/PNG of a Tinder/Bumble screen, or the whole conversation text.",
    landingStep2Title: "AI looks & thinks",
    landingStep2Desc: "Vision reads photos and bio. Deep model produces the psychological diagnosis.",
    landingStep3Title: "You get a strategy",
    landingStep3Desc: "A concrete message, first-date idea, and what to avoid.",
    premiumStreamReveal: "Sections appear one by one",
    premiumStreamWaiting: "AI is generating the report section by section...",
    couponLabel: "Have a coupon code?",
    couponApply: "Apply",
    couponClear: "Remove",
    couponApplied: "Coupon active — {p}% off",
    couponInvalid: "Coupon invalid, expired or already used",
    couponExpires: "Valid until",
    standardAnalysis: "Standard analysis",
    uploadSlotMain: "main photo",
    uploadSlotExtra: "additional",
    previewNoPhoto: "Drop a photo to see the preview",
    previewUnnamed: "Unknown profile",
    mode_conversation: "Chat",
    mode_profile: "Profile",
    mode_photos: "Photos",
    mode_full: "Full",
  },
};

export const SCORE_KEYS = [
  "response_chance",
  "interest",
  "meeting_chance",
  "chemistry",
  "ghosting_risk",
  "profile_strength",
  "photo_quality",
  "bio_quality",
];
